import { NgIf } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { Store } from '@ngrx/store';

import { ManageSavedListsComponent } from '@components/orders/saved-lists/manage-saved-lists/manage-saved-lists.component';
import { filter, take } from 'rxjs/operators';

import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { selectSingleListLoading } from '../../../../@store/orders/orders.selectors';

export interface ListsAddEditModalData {
  listItem: { id: number } | null;
  isAdd?: boolean;
  filtersForm?: {
    statusFilter: string | null;
    assigneeFilter: string | null;
    fromDate: Date | null;
    toDate: Date | null;
    userFilter: string | null;
  };
}

@Component({
  selector: 'ciwc-lists-add-edit-modal',
  imports: [
    ManageSavedListsComponent,
    MatDialogContent,
    MatDialogTitle,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatProgressSpinnerModule,
    NgIf,
  ],
  standalone: true,
  templateUrl: './lists-add-edit-modal.component.html',
  styleUrl: './lists-add-edit-modal.component.scss',
})
export class ListsAddEditModalComponent {
  private readonly store = inject(Store);
  readonly loading$ = this.store.selectSignal(selectSingleListLoading);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ListsAddEditModalData | null,
    private dialogRef: MatDialogRef<ListsAddEditModalComponent>,
  ) {}

  onSubmit() {
    console.log('Form submitted');
  }

  onSaveList(event: { id: number | undefined; payload: any }) {
    if (event.id) {
      // Edit mode
      this.store.dispatch(OrdersActions.updateSingleList({ id: event.id, payload: event.payload }));
    } else {
      // Add mode
      this.store.dispatch(OrdersActions.createSingleList({ payload: event.payload }));
    }

    // Wait for the operation to complete
    this.store
      .select(selectSingleListLoading)
      .pipe(
        filter((loading) => !loading),
        take(1),
      )
      .subscribe(() => {
        this.dialogRef.close(true);
      });
  }
}
